import { GET, POST } from '../http';

export const GetBankDetailsReport = spec => {
    return POST("BankDepositsReport/GetBankDepositsReport", spec)
}

export const GetPaymentArrangements = spec => {
    return GET("PaymentArrangementDataService/GetPaymentArrangements", spec)
}

export const GetCumulativeDetailedIncomeReport = spec => {
    return GET("CumulativeDetailedIncome/GetCumulativeDetailedIncomeReport", spec)
}

export const GetCurrency = spec => {
    return GET("Currency/GetCurrenciesInfo", spec)
}

export const GetFoliosDetails = spec => {
    return POST("Folio/FoliosDetails", spec)
}

export const GetFolios = spec => {
    return GET("Folio/GetFolios", spec)
}

export const SearchFolios = spec => {
    return GET("Folio/SearchFolios", spec)
}

export const GetArrangementGroups = spec => {
    return GET("PaymentArrangement/GetArrangementGroups", spec)
}

export const GetAddonsByReservationReport = spec => {
    return GET("AddonsReports/GetAddonsByReservationReport", spec)
}
export const GetAddonsCommissionsReport = spec => {
    return GET("AddonsReports/GetAddonsCommissionsReport", spec)
}
export const GetUsers = spec => {
    return GET("Folio/GetUsers", spec)
}
export const PostBooking = spec => {
    return POST("Folio/PostBooking", spec)
}

export const ValidateIsEnableCancelPostBooking = ({HotelId, ReservationIds})=>{
    return POST("Folio/ValidateIsEnableCancelPostBooking", {HotelId, ReservationIds})
}

export const CancelPostBooking = ({HotelId, ReservationIds})=>{
    return POST("Folio/CancelPostBooking", {HotelId, ReservationIds})
}
export const CreateFolios = spec=>{
    return POST("Folio/NewFoliosForEntities", spec)
}
export const SaveTokenFromIFrameResponse = spec=>{
    return POST("CreditGuardReturn/SaveTokenFromIFrameResponse", spec)
}

export const GetTransactionCodes = spec=>{
    return GET("TransactionCode/GetTransactionCodes", spec)
}

export const CalculateAmountTax = spec=>{
    return POST("Folio/CalculateAmountTax", spec)
}

export const UpdateFolioTransactionProperties = spec => {
    return POST("BankDeposits/UpdateFolioTransactionProperties", spec);
}

export const RenderTemplateWithReCalcTax = spec => {
    return POST("Finance/Invoice/RenderTemplateWithReCalcTax", spec);
}

export const RenderTemplateToPdf = spec => {
    return POST("Finance/Folio/RenderTemplateToPdf", spec);
}
export const CreateStornoInvoice = spec => {
    return POST("Finance/Invoice/CreateStornoInvoice", spec);
}

export const SendEmail = spec => {
    return POST("Finance/Invoice/SendEmail", spec);
}
export const GetFoliosForChainHotels = spec => {
    return GET("Folio/GetFoliosForChainHotels", spec)
}

export const GetCurrencyRates = spec=>{
    return GET("Finance/Folio/GetCurrencyRates", spec)
}

export const InsertTransactions = spec => {
    return POST("Finance/Folio/InsertTransactions", spec);
}

export const PostInvoice = spec => {
    return POST("Finance/Invoice/PostInvoice", spec);
}

// HS-69601: invoice balance after tax exemption recalculation (settlement popup amount)
export const GetInvoiceSettlementBalance = spec => {
    return POST("Finance/Invoice/GetInvoiceSettlementBalance", spec);
}

// HS-69601: inserts spec.NewFolioTransactions (payment) and posts the invoice in one call
export const SettleAndPostInvoice = spec => {
    return POST("Finance/Invoice/SettleAndPostInvoice", spec);
}

// HS-69601: SettleAndPostInvoice's balance check without saving (card tab, before charging the card)
export const ValidateInvoiceSettlement = spec => {
    return POST("Finance/Invoice/ValidateInvoiceSettlement", spec);
}

export const IssueInvoice = spec => {
    return POST("Finance/Invoice/IssueInvoice", spec);
}

export const GetGuestTitles = spec=>{
    return GET("Finance/Folio/GetGuestTitles", spec)
}

export const CalculateFolioTransactionsByTargetCurrencyId = spec=>{
    return POST("Finance/Folio/CalculateFolioTransactionsByTargetCurrencyId", spec)
}

export const GetDetailedCashReport = spec=>{
    return GET("FinanceReports/DetailedCash/SearchDetailedCashReportData", spec)
}

export const CreditCardAPIPayment = spec=>{
    return POST("Finance/ShortActions/CreditCardAPIPayment", spec)
}

export const CreditCardAPIPaymentSave = spec=>{
    return POST("Finance/ShortActions/CreditCardAPIPaymentSave", spec)
}

export const GetBanks = spec=>{
    return GET("Finance/Folio/GetBanks", spec)
}

export const CalculateAmountBeforeTax = spec=>{
  return POST("Finance/Invoice/CalculateAmountBeforeTax", spec)
}

export const GetMonthIncomeReport = spec=>{
    return GET("FinanceReports/Income/GetMonthIncomeReport", spec)
}

export const GetReservationDistributionByAgentReport = spec=>{
    return GET("PMSReports/SPAReports/GetReservationDistributionByAgentReport", spec)
}
export const GetIncomeReportData = spec=>{
    return GET("FinanceReports/Income/GetIncomeReport", spec)
}
export const GetReport = spec=>{
    return GET("Finance/AccountingSystem/GetReport", spec)
}

